/**
 * 抖音SDK
 * https://developer.open-douyin.com/docs/resource/zh-CN/dop/develop/sdk/web-app/js/permission
 */

import wechatApi from '@/api/wechat';
import Utils from '@/utils/utils';
import { DEFAULT_DOUYIN_OFFICIAL_ACCOUNTS_ID } from '@/config';

let Jdouyin = window.douyin_open || {};
let ready = false;
let params = {
  clientKey: 'awgosixnxor2d7j1',
  timestamp: String(parseInt(Date.now() / 1000)),
  nonceStr: 'Wm3WZYTPz0wzccnW',
  url: window.location.href
};

if(Jdouyin) {
  console.log('SDK Loaded');
}

// 可在URL参数中自定义JSB方法名和参数以测试
export const checkJSB = (jsb) => {
  if(ready) {
    Jdouyin[jsb]({
      params,
      success: res => console.log(`JSB ${jsb} Success: ${JSON.stringify(res)}`),
      error: res => console.log(`JSB ${jsb} Error: ${JSON.stringify(res)}`)
    });
  }
};

export const init = async () => {

  if(!Utils.browser().douyin || !Jdouyin) return;

  let data = await wechatApi.getDouyinParam({ url: params.url, officialAccountsId: DEFAULT_DOUYIN_OFFICIAL_ACCOUNTS_ID });

  params = Object.assign(params, data);

  const { url, signature, timestamp, nonceStr, clientKey } = params;

  Jdouyin.config({
    params: {
      client_key: clientKey,
      signature,
      timestamp: String(timestamp),
      nonce_str: nonceStr,
      url
    }
  });

  Jdouyin.ready((res) => {
    console.log('ready==>');
    ready = true;
  });

  Jdouyin.error(res => {
    alert(JSON.stringify(Object.assign(res, { res: 'error' })));
  });
};

//跳转授权，会单独打开一个页面
export const jumpOpenAuth = async (args = {}) => {
  if(ready) {
    const { success, error } = args;

    Jdouyin.jumpOpenAuth({
      params: {
        client_key: params.clientKey,
        redirect_uri: window.location.href,
        state: '',
        scope: 'user_info',
        response_type: 'code'
      },
      success: (res) => {
        success && success(res);
      },
      error: res => {
        error && error(res);
      }
    });
  } else {
    await init();
  }
};

//唤起授权，会弹起一个悬浮框
export const showOpenAuth = async (args = {}) => {
  if(ready) {
    const { success, error } = args;
    Jdouyin.showOpenAuth({
      params: {
        client_key: params.clientKey, // clientKey在你的网页应用申请通过后得到
        // redirect_uri: window.location.href,
        state: '', // 自定义状态，详见下方说明
        scopes: {
          user_info: 0 // 0: 必选；1: 可选，默认不选中； 2: 可选，默认选中
        },
        response_type: 'code' // 默认填‘code’，详见下方说明
      },
      success: (res) => {
        success && success(res);
      },
      error: res => {
        error && error(res);
      }
    });
  } else {
    await init();
  }
};

export const douyinVersion = () => {
  const APP_VERSION_REGX = {
    android: new RegExp('app_version/', 'i'),
    ios: new RegExp('aweme_', 'i')
  };
  const ua = navigator.userAgent;
  const os = /(Android);?\s+([\d.]+)?/i.test(ua) ? 'android' : 'ios';
  const version = parseFloat(ua.split(APP_VERSION_REGX[os])[1]);
  // openConfig 验签上线抖音版本为10.4.0， showOpenAuth 上线时间为10.8.0，低版本抖音是无法唤起半屏授权的
  return version;
};